import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { TypographyComponent as TypographyElement, LoadingSpinner } from '@tvg/fuse-design';

const ReviewsTitle = styled(TypographyElement)`
  margin-bottom: var(--spacing-space16);
`;

const Container = styled.div`
  padding: var(--spacing-space32) 0 var(--spacing-space16) 0;
  border-top: 1px solid var(--color-global-grey400);

  // IMPORTANT - The below CSS properties need the !important flag in order to overwrite default Bazaarvoice styles.
  #BVRRContainer .bv-action-bar,
  #BVRRContainer .bv-rating-none {
    display: none !important;
  }

  #BVRRContainer .bv-content-placeholder {
    margin-left: 0 !important;
  }

  #BVRRContainer .bv-section-summary {
    margin-top: var(--spacing-space32) !important;
  }

  #BVRRContainer .bv-content-noreviews-label {
    color: var(--color-global-grey900) !important;
    font-family: var(--font-brand), Arial, Helvetica, sans-serif !important;
    font-size: var(--font-size-m1) !important;
    line-height: var(--font-line-height-m1) !important;
  }
`;

type Props = {
  productId: string;
  BV_URL: string;
};

const Reviews = React.memo((props: Props) => {
  const { productId, BV_URL } = props;
  const [BVloading, setIsBVLoading] = useState(false);

  useEffect(() => {
    // Check if the script already exists
    const scriptExists = document.querySelector(`script[src="${BV_URL}"]`);
    if (!scriptExists) {
      setIsBVLoading(true); // Set loading state to true while the script loads
      const script = document.createElement('script');
      script.src = BV_URL;
      script.async = true;
      script.onload = () => {
        setIsBVLoading(false); // Update state once the script is loaded
      };
      document.head.appendChild(script);
    }
  }, []);

  return (
    <Container id="ratings-and-reviews" data-testid="ratings_and_reviews">
      <ReviewsTitle tag="h2" size="3">
        Customer reviews
      </ReviewsTitle>

      {BVloading && (
        <div data-testid="ratings_and_reviews_loading">
          <LoadingSpinner size="small" variant="secondary" />
        </div>
      )}
      {!BVloading && (
        <div data-bv-show="reviews" data-bv-product-id={productId} data-testid="ratings_and_reviews_reviews" />
      )}
    </Container>
  );
});

export default Reviews;
